import _ from "lodash";
import { Amounts, Quote } from "./types";

export const stateMap = [
  { value: "AC", label: "Acre" },
  { value: "AL", label: "Alagoas" },
  { value: "AP", label: "Amapá" },
  { value: "AM", label: "Amazonas" },
  { value: "BA", label: "Bahia" },
  { value: "CE", label: "Ceará" },
  { value: "DF", label: "Distrito Federal" },
  { value: "ES", label: "Espírito Santo" },
  { value: "GO", label: "Goiás" },
  { value: "MA", label: "Maranhão" },
  { value: "MT", label: "Mato Grosso" },
  { value: "MS", label: "Mato Grosso do Sul" },
  { value: "MG", label: "Minas Gerais" },
  { value: "PA", label: "Pará" },
  { value: "PB", label: "Paraíba" },
  { value: "PR", label: "Paraná" },
  { value: "PE", label: "Pernambuco" },
  { value: "PI", label: "Piauí" },
  { value: "RJ", label: "Rio de Janeiro" },
  { value: "RN", label: "Rio Grande do Norte" },
  { value: "RS", label: "Rio Grande do Sul" },
  { value: "RO", label: "Rondônia" },
  { value: "RR", label: "Roraima" },
  { value: "SC", label: "Santa Catarina" },
  { value: "SE", label: "Sergipe" },
  { value: "SP", label: "São Paulo" },
  { value: "TO", label: "Tocantins" },
];

export const intToDec = (int: number) => {
  const floatString = (int / 100).toFixed(2);
  const [rawWhole, decimal] = floatString.split(".");
  const whole = rawWhole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${whole},${decimal}`;
};

export const intToBrl = (int: number) => {
  const floatString = (int / 100).toFixed(2);
  const [rawWhole, decimal] = floatString.split(".");
  const whole = rawWhole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `R$ ${whole},${decimal}`;
};

export const intToBrlWhole = (int: number) => {
  const floatString = (int / 100).toFixed(2);
  const [rawWhole] = floatString.split(".");
  const whole = rawWhole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `R$ ${whole}`;
};

export const brlToInt = (brl: string) => {
  if (brl === "") return 0;

  if (!brl.includes(",")) return parseInt(brl.replace(/\D/g, "")) * 100;

  const [rawWhole, rawDecimal] = brl.split(",");
  const decimal =
    rawDecimal.length === 2
      ? rawDecimal
      : rawDecimal.length === 1
        ? `${rawDecimal}0`
        : "00";
  const whole = rawWhole.replace(/\D/g, "");

  return whole === "" ? parseInt(decimal) : parseInt(`${whole}${decimal}`);
};

export const formatAddress = ({
  street,
  number,
  city,
  state,
  zipcode,
}: {
  street: string;
  number: string;
  city: string;
  state: string;
  zipcode: string;
}) => `${street}, ${number}, ${city}, ${state} – ${zipcode}`;

export const getAmounts = (quote: Quote): Amounts => {
  const baseSale = _.chain(quote.itemsSold)
    .map((i) => i.price * i.amount)
    .sum()
    .valueOf();
  const finalSale = baseSale - quote.discountSale;

  const baseRent = _.chain(quote.itemsRented)
    .map((i) => i.price * i.amount)
    .push(quote.feeMonitoring)
    .sum()
    .valueOf();
  const finalRent = baseRent - quote.discountRent;

  return {
    baseSale,
    baseRent,
    finalSale,
    finalRent,
    fee: quote.feeInstall + quote.feeReview,
  };
};
